import styled from "styled-components";
import theme from "~/styles/theme";
import { Button } from "~/components/elements";

export const FormHolder = styled.div`
  padding: 0 16px;
  margin: 0 auto;
  text-align: center;

  .ctn {
    display: flex;
    justify-content: center;
  }

  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    max-width: 500px; 
    span {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  a {
    font-family: ${theme.typography.fontFamily};
    color: ${theme.palette.brand.primary.key};
    font-size: 16px;
    text-align: right;

    p {
      color: ${theme.palette.brand.primary.key};
    }
  }
`;

export const FormLimiter = styled.form`
  button {
    width: 100%;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 496px;
    margin: 0 auto;
  }

  p {
    font-family: ${theme.typography.fontFamily};
    text-align: center;
  }
`;

export const ErrorText = styled.div`
  p {
    color: ${(props) =>
      props.success
        ? theme.palette.feedback.success.key
        : theme.palette.feedback.error.key};
  }
`;

export const SuccessMessage = styled.p`
  text-align: center;
  color: ${theme.palette.feedback.success.key} !important;
  margin: 0;
`;

export const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    width: 153px;
    display: block;
    
    &:hover {
      background-color: white;
      color: ${theme.palette.brand.primary.key};
      border: none;
    }
  }

  @media (max-width: ${theme.breakpoints.values.md}px) {
    button {
      width: 100%;
    }
  }
`;

export const BtnSignUp = styled(Button)`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 2px solid ${theme.palette.brand.primary.key};
  cursor: pointer;
  padding: 10px 24px;
  border-radius: 32px;
  font-weight: 400;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 0;
    margin-right: 24px;
  }

  &:hover {
    border-color: ${theme.palette.brand.primary.key};
    background-color: ${theme.palette.brand.primary.key};

    span {
      color: ${theme.palette.neutral.primary.light};
      display: flex;

      svg path {
        fill: white;
      }
    }
  }

  span {
    color: ${theme.palette.brand.primary.key};
    display: flex;
  }
`;

export const TextHolder = styled.div`
  background-color: ${theme.palette.neutral.primary.light};
  padding: 48px;
  border-radius: 32px;

  .text-container{
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    color: ${theme.palette.brand.primary.key};
    font-family: ${theme.typography.fontFamily};
    text-align: center;
    font-weight: 700;
  }

  a {
    text-decoration: none;
  }

  button {
    width: 100%;
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 496px;
  }

`;
